import { List } from "basis";

function CloseAccountImportantInformationList({ canHaveRewardPoints }) {
  return (
    <List variant="danger">
      <List.Item>
        You will not be able to reopen this account once it’s been closed.
      </List.Item>
      <List.Item>
        You will be liable for any purchases and charges not yet posted to this
        account after you request to close your account.
      </List.Item>
      <List.Item>
        Any direct debits associated to this account will be cancelled.
      </List.Item>
      <List.Item>
        Any consumer credit insurance from Latitude Insurance will be cancelled.
      </List.Item>
      {canHaveRewardPoints && (
        <List.Item>Reward points must be redeemed before closure.</List.Item>
      )}
    </List>
  );
}

export { CloseAccountImportantInformationList };
